import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.keys.js";
import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-next-line import/no-extraneous-dependencies -- directive added automatically by Shepherd migration

import ReactDOM from 'react-dom'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get';
/**
 * Mapping of supported React synthetic event handlers to element interaction event type
 * react events: https://facebook.github.io/react/docs/events.html
 * element interaction schema: https://github.com/NerdWallet/schemas/blob/master/protobuf/src/event/ElementInteractionTypeEnum.proto
 */

export var INTERACTION_TYPES = {
  CLICK: 'onClick',
  HOVER: 'onMouseOver',
  MOUSE_DOWN: 'onMouseDown',
  MOUSE_UP: 'onMouseUp',
  MOUSE_ENTER: 'onMouseEnter',
  MOUSE_LEAVE: 'onMouseLeave',
  KEY_DOWN: 'onKeyDown',
  KEY_UP: 'onKeyUp',
  KEY_PRESS: 'onKeyPress',
  LOAD: 'onLoad',
  DRAG: 'onDrag',
  DRAG_START: 'onDragStart',
  DRAG_END: 'onDragEnd',
  DRAG_ENTER: 'onDragEnter',
  DRAG_LEAVE: 'onDragLeave',
  DRAG_OVER: 'onDragOver',
  DROP: 'onDrop',
  PLAY: 'onPlay',
  PAUSE: 'onPause',
  ANIMATE_START: 'onAnimationStart',
  ANIMATE_END: 'onAnimationEnd',
  COPY: 'onCopy',
  CUT: 'onCut',
  PASTE: 'onPaste',
  TOUCH_START: 'onTouchStart',
  TOUCH_END: 'onTouchEnd',
  TOUCH_CANCEL: 'onTouchCancel',
  TOUCH_MOVE: 'onTouchMove'
};

var ElementInteraction = /*#__PURE__*/function (_React$Component) {
  _inherits(ElementInteraction, _React$Component);

  var _super = _createSuper(ElementInteraction);

  function ElementInteraction() {
    _classCallCheck(this, ElementInteraction);

    return _super.apply(this, arguments);
  }

  _createClass(ElementInteraction, [{
    key: "fireElementInteraction",
    value: function fireElementInteraction(interactionType) {
      if (typeof window === 'undefined' || !window.nwa) {
        return;
      } // Try to grab element dom types if not explictly passed in


      var childDOMNode = ReactDOM.findDOMNode(this.child); // eslint-disable-line

      var elementDomType = // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.elementDomType || get(childDOMNode, 'nodeName');
      var parentElementDomType = // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.parentElementDomType || get(childDOMNode, 'parentNode.nodeName');

      var eventProps = _objectSpread({
        // props.id is supported for consistency across other tracking components
        elementInteractionHeader: {
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          elementCategory: this.props.elementCategory,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          elementContent: this.props.elementContent,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          elementCount: this.props.elementCount,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          elementDomId: this.props.elementDomId,
          elementDomType: elementDomType,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          elementName: this.props.elementName || this.props.id,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          elementPosition: this.props.elementPosition,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          impressionId: this.props.impressionId,
          interactionType: interactionType,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          pageNumber: this.props.pageNumber,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          parentElementDomId: this.props.parentElementDomId,
          parentElementDomType: parentElementDomType,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          sectionCategory: this.props.sectionCategory,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          sectionElementCount: this.props.sectionElementCount,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          sectionPosition: this.props.sectionPosition
        }
      }, this.props.verticalInteractionData); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


      window.nwa.track(this.props.eventName, eventProps);
    } // Get the individual child or wrap the children if it is an array/function/string

  }, {
    key: "convertChildrenToChild",
    value: function convertChildrenToChild() {
      var _this = this;

      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      var Component = this.props.component; // Convert text to React Element
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      if (typeof this.props.children === 'string') {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        return /*#__PURE__*/React.createElement(Component, null, this.props.children);
      } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


      if (Array.isArray(this.props.children)) {
        // Convert array to individual react element with children,
        // and pass `triggerImpression` to the array/function
        return /*#__PURE__*/React.createElement(Component, null, React.Children.map(this.props.children, function (child) {
          return _this.cloneChild(child);
        }));
      } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


      return this.props.children;
    }
  }, {
    key: "cloneChild",
    value: function cloneChild(child) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var childProps = _objectSpread({}, props);

      if (typeof child.type !== 'string') {
        // `triggerInteraction` is a prop passed so the consumer can manually
        // trigger the element interaction event if they have a complex
        // interaction. The interaction type will need to be passed in
        // at the call site. It's _not_ passed to DOM elements.
        childProps.triggerInteraction = this.fireElementInteraction.bind(this);
      } // Add support for anonymous inline function


      if (typeof child === 'function') {
        return child(childProps);
      }

      return /*#__PURE__*/React.cloneElement(React.Children.only(child), childProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var child = this.convertChildrenToChild();
      var childProps = {
        ref: function ref(c) {
          _this2.child = c;
        }
      }; // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      var interactions = [].concat(this.props.type);
      interactions.forEach(function (interaction) {
        var eventHandler = INTERACTION_TYPES[interaction]; // If the given child already has the associated event handler defined,
        // call both the element interaction event and the child event handler

        if (typeof get(child, "props[".concat(eventHandler, "]")) === 'function') {
          var childEventHandler = child.props[eventHandler];

          childProps[eventHandler] = function () {
            _this2.fireElementInteraction(interaction);

            childEventHandler.apply(void 0, arguments);
          };
        } else {
          childProps[eventHandler] = _this2.fireElementInteraction.bind(_this2, interaction);
        }
      });
      return this.cloneChild(child, childProps);
    }
  }]);

  return ElementInteraction;
}(React.Component);

var SUPPORTED_INTERACTIONS = Object.keys(INTERACTION_TYPES); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

ElementInteraction.defaultProps = {
  component: 'span',
  eventName: 'ELEMENT_INTERACTION_EVENT',
  verticalInteractionData: {}
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

ElementInteraction.displayName = 'ElementInteraction'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

ElementInteraction.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  children: PropTypes.any.isRequired,
  // If you pass in an array of children or a text, it will be wrapped with this node type.
  component: PropTypes.string,
  // The type of the element; this should be treated as an enum.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  elementCategory: PropTypes.string,
  // Content of the element.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  elementContent: PropTypes.string,
  // The total number of elements on the page.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  elementCount: PropTypes.number,
  // The DOM type of the element ('button', 'a').
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  elementDomType: PropTypes.string,
  // The DOM ID of the element
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  elementDomId: PropTypes.number,
  // The name of the element the user is interacting with
  elementName: PropTypes.string.isRequired,
  // The position of the element in the section.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  elementPosition: PropTypes.number,
  // Name of the element interaction event to be fired
  eventName: PropTypes.string,
  // Unique id that maps to the `elementName` in the DWH schema
  // We use the id here so it is consistent across other tracking
  // components.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  id: PropTypes.string,
  // Unique impression id.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  impressionId: PropTypes.string,
  // The page number on paginated output.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  pageNumber: PropTypes.number,
  // The DOM ID of the parent element
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  parentElementDomId: PropTypes.string,
  // The DOM type of the parent element.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  parentElementDomType: PropTypes.string,
  // The type of the section the element is in (e.g. recommendations, related-content).
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  sectionCategory: PropTypes.string,
  // The number of elements in the section.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  sectionElementCount: PropTypes.number,
  // The position order of the section in the page.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  sectionPosition: PropTypes.number,
  // The interaction type
  type: PropTypes.oneOfType([PropTypes.oneOf(SUPPORTED_INTERACTIONS), PropTypes.arrayOf(SUPPORTED_INTERACTIONS)]).isRequired,
  // Vertical specific tracking data
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  verticalInteractionData: PropTypes.object
};
export default ElementInteraction;